import md5Short from './md5'

var iPhotoWidth = 205;
var iPhotoHeight = 274;

var iVideoWidth = 420;
var iVideoHeight = 300;

var constraints = {
	audio: false,
	video : {
		width: iVideoWidth,
		height: iVideoHeight,
    facingMode: 'user'
	}
};

function rhex(c) {
  console.log("char" + c);
  var hex_chr = '0123456789ABCDEF'.split('');
  return hex_chr.indexOf(c);
}

var eCanvas = document.getElementById('canvas');
var ctx = eCanvas.getContext('2d');
eCanvas.width = 416;
eCanvas.height = 669;

var eBackCanvas = document.createElement('canvas');
var ctxBack = eBackCanvas.getContext('2d');

// Older browsers might not implement mediaDevices at all, so we set an empty object first
if (navigator.mediaDevices === undefined) {
  navigator.mediaDevices = {};
}

// Some browsers partially implement mediaDevices. We can't just assign an object
// with getUserMedia as it would overwrite existing properties.
// Here, we will just add the getUserMedia property if it's missing.
if (navigator.mediaDevices.getUserMedia === undefined) {
  navigator.mediaDevices.getUserMedia = function(constraints) {

    // First get ahold of the legacy getUserMedia, if present
    var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

    // Some browsers just don't implement it - return a rejected promise with an error
    // to keep a consistent interface
    if (!getUserMedia) {
      return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
    }

    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
    return new Promise(function(resolve, reject) {
      getUserMedia.call(navigator, constraints, resolve, reject);
    });
  }
}

navigator.mediaDevices.getUserMedia(constraints)
.then(function(stream){

	/* use the stream */
	var video = document.querySelector('video');
	video.srcObject = stream;

	video.onloadedmetadata = function(e) {
    eBackCanvas.width = video.videoWidth;
    eBackCanvas.height = video.videoHeight;
    iVideoWidth = video.videoWidth;
    iVideoHeight = video.videoHeight;

    //console.log(video);

		//video.play();
    render(true, true, null);
	};
})
.catch(function(err){
	console.log(err.name + ": " + err.message);
  render(true, false);
});



function render(firstPass, hasVideo, aFrame) {
  //console.log("render");


  //console.log("aFrame: " + aFrame);
  var aVidFrame = aFrame;

  ctx.beginPath();
    ctx.fillStyle = "rgb(0, 120, 231)";
    ctx.rect(20, 50, iPhotoWidth, iPhotoHeight);
    ctx.fill();

    ctx.fillStyle = "rgb(255, 255, 255)";
    ctx.font = "12px consolas,monospace";
  ctx.closePath();

  // Render the ID photo.
  var eVideo = document.querySelector('video');
  if (!hasVideo) {
    ctx.beginPath();
    iWidth = ctx.measureText("Allow Camera Access").width | 0;
    ctx.fillText("Allow Camera Access", (iPhotoWidth-iWidth)/2 + 15, 187);
    ctx.closePath();

  } else if (hasVideo && eVideo.paused && !aFrame) {
    ctx.beginPath();
    iWidth = ctx.measureText("Tap Video On").width | 0;
    ctx.fillText("Tap Video On", (iPhotoWidth-iWidth)/2 + 15, 187);
    ctx.closePath();

  } else if (hasVideo && !eVideo.paused) {
    ctxBack.drawImage(document.getElementById('player'), 0, 0, iVideoWidth, iVideoHeight);
    var aPixels = ctxBack.getImageData(0, 0, iPhotoWidth, iPhotoHeight);

    var aBPixels = ctxBack.getImageData(0, 0, iPhotoWidth, iPhotoHeight);
    for (var row = 0; row < aPixels.height; row++) {
      for (var col = 0; col < aPixels.width; col++) {
        aBPixels.data[(row * aPixels.width + (aPixels.width - col)) * 4 + 0] =
        aPixels.data[(row * aPixels.width + col) * 4 + 0];
        aBPixels.data[(row * aPixels.width + (aPixels.width - col)) * 4 + 1] =
        aPixels.data[(row * aPixels.width + col) * 4 + 1];
        aBPixels.data[(row * aPixels.width + (aPixels.width - col)) * 4 + 2] =
        aPixels.data[(row * aPixels.width + col) * 4 + 2];
        aBPixels.data[(row * aPixels.width + (aPixels.width - col)) * 4 + 3] =
        aPixels.data[(row * aPixels.width + col) * 4 + 3];

      }
    }

    aVidFrame = aBPixels;
    ctx.putImageData(aBPixels, 20, 50);
  } else if (aFrame) {
    ctx.putImageData(aFrame, 20, 50);
  }

  if (firstPass) {
    var sGovt = "UNITED STATES GOVERNMENT";
    ctx.beginPath();
    ctx.fillStyle = "rgb(0, 0, 0)";
    ctx.font = "26px \"Courier New\",monospace";

    var iWidth = ctx.measureText(sGovt).width | 0;
    ctx.fillText(sGovt, (416-iWidth)/2, 35);
    ctx.closePath();

  	var sig_image = new Image();
    sig_image.src = './images/sig.png';
    sig_image.onload = function(){
      ctx.drawImage(sig_image, 240, 165, 159, 61);
    }

    var bul_image = new Image();
    bul_image.src = './images/bullets.jpg';
    bul_image.onload = function(){
      ctx.drawImage(bul_image, 19, 327, 206, 43);
    }

    var lem_image = new Image();
    lem_image.src = './images/isru.png';
    lem_image.onload = function(){
      ctx.drawImage(lem_image, 245, 240, 150, 56);
    }

    var nasa_image = new Image();
    nasa_image.src = './images/nasa.png';
    nasa_image.onload = function(){
      ctx.drawImage(nasa_image, 235, 45, 172, 144);
    }
  }

  ctx.beginPath();
  ctx.fillStyle = "rgb(144, 0, 21)";
  ctx.rect(235, 334, 34, 29);
  ctx.fill();
  ctx.closePath();

  ctx.beginPath();
  ctx.fillStyle = "rgb(220, 76, 51)";
  ctx.rect(269, 334, 34, 29);
  ctx.fill();
  ctx.closePath();

  ctx.beginPath();
  ctx.fillStyle = "rgb(246, 217, 63)";
  ctx.rect(303, 334, 34, 29);
  ctx.fill();
	ctx.closePath();

	ctx.beginPath();
  ctx.fillStyle = "rgb(51, 60, 55)";
  ctx.rect(337, 334, 34, 29);
  ctx.fill();
	ctx.closePath();

	ctx.beginPath();
  ctx.fillStyle = "rgb(15, 31, 73)";
  ctx.rect(371, 334, 34, 29);
  ctx.fill();
	ctx.closePath();

  ctx.beginPath();
  ctx.strokeStyle = "rgb(0, 0, 0)";
  ctx.moveTo(0,12);
  ctx.lineTo(0,372);
  ctx.stroke();
  ctx.closePath();

  ctx.beginPath();
  ctx.strokeStyle = "rgb(0, 0, 0)";
  ctx.moveTo(416,12);
  ctx.lineTo(416,375);
  ctx.stroke();
  ctx.closePath();

  ctx.beginPath();
  ctx.strokeStyle = "rgb(0, 0, 0)";


  if (firstPass) {
    ctx.beginPath();
    ctx.arc(12, 12, 12, 1.0 * Math.PI, 1.5 * Math.PI, false);
    ctx.moveTo(12,0);
    ctx.lineTo(404,0);
    ctx.arc(404, 12, 12, 1.5 * Math.PI, 2.0 * Math.PI, false);
    ctx.stroke();
    ctx.closePath();
  }

  var fName = document.getElementById("fName").value;
  if (!fName) {
    fName = document.getElementById("fName").placeholder;
  }

  var lName = document.getElementById("lName").value;
  if (!lName) {
    lName = document.getElementById("lName").placeholder;
  }
  //console.log("First Name:" + fName);
	renderDetails(fName, lName, 372, hasVideo, aVidFrame);
}

function renderDetails(sFirstName, sLastName, iYpos, hasVideo, aFrame) {
  var sProperty = "PROPERTY OF THE TOM SACHS STUDIO";
  var rules = [
    "IF A GUEST IN YOUR LAIR ANNOYS YOU, TREAT THEM CRUELLY AND WITHOUT MERCY",
    "CHANGE WHAT YOU CAN",
    "DON'T BOTHER WHAT YOU CAN'T",
    "MENDING IS BETTER THAN ENDING, PRACTICE BRICOLAGE",
    "DO NOT KILL UNLESS YOU ARE ATTACKED OR FOR YOUR FOOD",
    "DO NOT HARM LITTLE CHILDREN",
    "AN ARTIST'S BEST WORK LIES JUST BEYOND THEIR ABILITY TO UNDERSTAND IT",
    "WHEN IN ANOTHER'S LAIR, SHOW THEM RESPECT OR ELSE DO NOT GO THERE",
    "BE AFRAID AND DO IT ANYWAY",
    "ANYTHING BUT THE GIRL"
  ];
  var id = md5Short(sFirstName + " " + sLastName);
  var rId = (rhex(id[0]) + rhex(id[1]))%10;
  //console.log("id: "+ rId);
  var sRule = rules[rId];
	var d = new Date();

	ctx.beginPath();
	ctx.fillStyle = "rgb(51, 60, 55)";
	ctx.rect(0, 0+iYpos, 416, 274);
  ctx.rect(12, 274+iYpos, 394, 12);
	ctx.arc(12, 274+iYpos, 12, 0, 1 * Math.PI, false);
	ctx.arc(404, 274+iYpos, 12, 0, 1 * Math.PI, false);

	ctx.fill();

	ctx.fillStyle = "rgb(255, 255, 255)";

	ctx.font = "bold 50px Helvetica";
	ctx.fillText("INTERN", 20, 60+iYpos);

	ctx.font = "bold 30px Helvetica";
	ctx.fillText(sFirstName, 20, 120+iYpos);
	ctx.fillText(sLastName, 20, 150+iYpos);

	ctx.font = "26px Helvetica";
  ctx.fillText("S/N "+d.getFullYear()+"."+md5Short(sFirstName + " " + sLastName), 20, 200+iYpos);

	ctx.font = "22px Helvetica";
	ctx.fillText(d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate(), 20, 224+iYpos);

  ctx.font = "13px \"Courier New\",monospace";
  var iWidth = ctx.measureText(sProperty).width | 0;
  ctx.fillText(sProperty, (416-iWidth)/2, 260+iYpos);

  ctx.font = "9px \"Courier New\",monospace";
  iWidth = ctx.measureText(sRule).width | 0;
  ctx.fillText(sRule, (416-iWidth)/2, 275+iYpos);

  ctx.closePath();

  setTimeout(function() {render(false, hasVideo, aFrame);}, 100);
}


console.log("done");